import {Provinces} from "@app/constants/Provinces";
import React from "react";

export const INPUT_TYPE = {
    UPLOAD_CV: '1',
    INPUT_PART: '2'
}

export const OBJECT_SPECIALS = [
    {value: "", label: ""},
    {value: "n/a", label: "N/A"},
    {value: "boss", label: "Boss"},
    {value: "hr", label: "HR"},
    {value: "recruiter", label: "Recruiter"},
    {
        value: "làm tại các cty hhunt/agency tuyển dụng (k phải hr, recruiter)",
        label: "Làm tại các Cty hhunt/Agency Tuyển dụng (k phải HR, Recruiter)"
    },
]

export const JOB_SEND_REQUESTS = [
    {value: "n/a", label: "N/A"},
    {value: "không gửi email bất cứ job nào", label: "Không gửi email bất cứ JOB nào"},
    {
        value: "chỉ gửi job fit với chính họ, không gửi để xin refer",
        label: "Chỉ gửi job fit với chính họ, không gửi để xin refer"
    },
    {value: "chỉ gửi job gần (bằng trên dưới 1 level)", label: "Chỉ gửi job gần (bằng trên dưới 1 level)"},
    {value: "gửi job có đặc điểm nhất định", label: "Gửi job có đặc điểm nhất định"},
    {value: "gửi jobs theo tuần", label: "Gửi jobs theo tuần"},
    {value: "các yêu cầu đặc biệt vv gửi job khác", label: "Các yêu cầu đặc biệt vv gửi job khác"},
]

export const ENGAGEMENT_STATUS = [
    {value: "kh cũ", label: "KH cũ"},
    {value: "kh hiện tại", label: "KH hiện tại"},
    {value: "thân", label: "Thân"},
    {value: "met", label: "Met"},
    {value: "called", label: "Called"},
    {value: "chatted", label: "Chatted"},
    {value: "chatted linkedin", label: "Chatted Linkedin"},
    {value: "processed job", label: "Processed job"},
    {value: "emailed (mời job)", label: "Emailed (mời job)"},
    {value: "emailed (others)", label: "Emailed (others)"},
]

export const CALLER_NAMES = [
    'anh', 'chị'
]

// Loại duyên nợ
export const FATE_TYPES = [
    {value: "từng làm gì đó có lỗi với user", label: "Từng làm gì đó có lỗi với user"},
    {value: "user từng làm gì đó có lỗi với uv", label: "User từng làm gì đó có lỗi với UV"},
    {value: "từng được user giúp đỡ", label: "Từng được user giúp đỡ"},
    {value: "từng giúp đỡ user (refer uv)", label: "Từng giúp đỡ user (refer UV)"},
    {value: "từng rep email", label: "Từng rep email"},
    {value: "từng apply job", label: "Từng apply job"},
]

// Nhập list ME
export const ME_LIST_INPUT = [
    {value: "1", label: "N/A"},
    {value: "2", label: "Nhập list ME"},
    {value: "3", label: "Loại khỏi list ME"},
]

// Khả năng support
export const SUPPORT_LEVEL = [
    {value: "n/a", label: "N/A"},
    {value: "network rộng", label: "Network rộng"},
    {value: "hỗ trợ thtin tốt - về chuyên môn", label: "Hỗ trợ thtin tốt - về chuyên môn"},
    {
        value: "hỗ trợ thtin tốt - về thị trường lao động (uv, cty)",
        label: "Hỗ trợ thtin tốt - về thị trường lao động (UV, Cty)"
    }
]

// Khả năng sẵn sàng support
export const SUPPORT_READY_LEVEL = [
    {
        value: "nhiệt tình, hứng thú với việc giúp refer uv (không đòi hỏi $)",
        label: "Nhiệt tình, hứng thú với việc giúp refer UV (không đòi hỏi $)"
    },
    {value: "muốn có $ mới hợp tác", label: "Muốn có $ mới hợp tác"},
    {value: "kiểu người thik giúp đỡ", label: "Kiểu người thik giúp đỡ"},
    {value: "nể mà giúp", label: "Nể mà giúp"},
    {value: "thân thiện, cởi mở", label: "Thân thiện, cởi mở"},
    {value: "không giúp", label: "Không giúp"},
]

// Danh hiệu support
export const SUPPORT_TITLE = [
    {value: "n/a", label: "N/A"},
    {value: "n/a", label: "N/A"},
    {value: "nói sẽ chuyển ttin / có uv sẽ báo lại...", label: "Nói sẽ chuyển ttin / Có UV sẽ báo lại..."},
    {value: "đã từng support thtin", label: "Đã từng Support thtin"},
    {value: "refer nhiều lần", label: "Refer nhiều lần"},
    {value: "support thtin nhiều lần", label: "Support thtin nhiều lần"},
    {value: "referer ruột", label: " Referer ruột"},
    {value: "info supporter ruột", label: "Info Supporter ruột"},
]

export const RELATION_TYPES = [
    {value: "ref check trong cv - người được nhận xét", label: "Ref Check trong CV - người được nhận xét"},
    {value: "ref check trong cv - người nhận xét", label: "Ref Check trong CV - người nhận xét"},
    {value: "referer", label: "Referer"},
    {value: "referee", label: "Referee"},
    {value: "check ref process - người được nhận xét", label: "Check Ref process - người được nhận xét"},
    {value: "check ref process - người nhận xét", label: "Check Ref process - người nhận xét"},
    {value: "quản lý trực tiếp", label: "Quản lý trực tiếp"},
    {value: "cấp dưới trực tiếp", label: "Cấp dưới trực tiếp"},
    {value: "đồng nghiệp cùng phòng/bộ phận", label: "Đồng nghiệp cùng phòng/bộ phận"},
    {value: "đồng nghiệp khác (cùng công ty)", label: "Đồng nghiệp khác (cùng công ty)"},
    {value: "bạn thân", label: "Bạn thân"},
    {value: "bạn khác", label: "Bạn khác"},
    {value: "gia đình (tu than phu mau, vo chong, con cai)", label: "Gia đình (tu than phu mau, vo chong, con cai)"},
    {value: "họ hàng gần", label: "Họ hàng gần"},
    {value: "họ hàng xa", label: "Họ hàng xa"},
    {value: "đối tác", label: "Đối tác"},
    {value: "quen biet khac", label: "Quen biet khac"},
]

export const INDUSTRY_FUNCTIONS = [
    {value: 'airlines/aviation', label: 'Airlines/Aviation'},
    {value: 'architecture & planning', label: 'Architecture & Planning'},
    {value: 'automotive', label: 'Automotive'},
    {value: 'accounting', label: 'Accounting'},
    {value: 'apparal & fashion', label: 'Apparal & Fashion'},
    {value: 'banking', label: 'Banking'},
    {value: 'biotechnology', label: 'Biotechnology'},
    {value: 'broadcast media', label: 'Broadcast Media'},
    {value: 'building materials', label: 'Building Materials'},
    {value: 'bz supply & equipment', label: 'Bz Supply & Equipment'},
    {value: 'capital markets', label: 'Capital Markets'},
    {value: 'chemicals', label: 'Chemicals'},
    {value: 'civil engineering', label: 'Civil Engineering'},
    {value: 'commercial real estate', label: 'Commercial Real Estate'},
    {value: 'computer & nw security', label: 'Computer & Nw Security'},
    {value: 'computer games', label: 'Computer Games'},
    {value: 'computer hw', label: 'Computer Hw'},
    {value: 'computer sw', label: 'Computer Sw'},
    {value: 'construction', label: 'Construction'},
    {value: 'consumer electronics', label: 'Consumer Electronics'},
    {value: 'consumer goods', label: 'Consumer Goods'},
    {value: 'cosmetics', label: 'Cosmetics'},
    {value: 'dairy', label: 'Dairy'},
    {value: 'design', label: 'Design'},
    {value: 'graphic design', label: 'Graphic Design'},
    {value: 'education management', label: 'Education Management'},
    {value: 'electrical/electronic manufacturing', label: 'Electrical/Electronic Manufacturing'},
    {value: 'entertainment', label: 'Entertainment'},
    {value: 'environmental service', label: 'Environmental Service'},
    {value: 'events service', label: 'Events Service'},
    {value: 'executive office', label: 'Executive Office'},
    {value: 'facility services', label: 'Facility Services'},
    {value: 'farming', label: 'Farming'},
    {value: 'financial service', label: 'Financial Service'},
    {value: 'fishery', label: 'Fishery'},
    {value: 'food & beverage', label: 'Food & Beverage'},
    {value: 'food production', label: 'Food Production'},
    {value: 'fund raising', label: 'Fund Raising'},
    {value: 'furniture', label: 'Furniture'},
    {value: 'government relations', label: 'Government Relations'},
    {value: 'graphic design', label: 'Graphic Design'},
    {value: 'health, wellness & fitness', label: 'Health, Wellness & Fitness'},
    {value: 'higher education', label: 'Higher Education'},
    {value: 'hospital & healthcare', label: 'Hospital & Healthcare'},
    {value: 'hospitality', label: 'Hospitality'},
    {value: 'human resources', label: 'Human Resources'},
    {value: 'import & export', label: 'Import & Export'},
    {value: 'industrial automation', label: 'Industrial Automation'},
    {value: 'information service', label: 'Information Service'},
    {value: 'information technology & service', label: 'Information Technology & Service'},
    {value: 'insurance', label: 'Insurance'},
    {value: 'international trade & development', label: 'International Trade & Development'},
    {value: 'internet', label: 'Internet'},
    {value: 'investment banking', label: 'Investment Banking'},
    {value: 'investment mngment', label: 'Investment Mngment'},
    {value: 'judiciary (legal)', label: 'Judiciary (legal)'},
    {value: 'law enforcement', label: 'Law enforcement'},
    {value: 'law practice', label: 'Law practice'},
    {value: 'legal service', label: 'Legal Service'},
    {value: 'legislative office', label: 'Legislative Office'},
    {value: 'leisure, travel & tourism', label: 'Leisure, Travel & Tourism'},
    {value: 'logistics & supply chain', label: 'Logistics & Supply Chain'},
    {value: 'luxury goods & jewelry', label: 'Luxury Goods & Jewelry'},
    {value: 'machinery', label: 'Machinery'},
    {value: 'management consulting', label: 'Management Consulting'},
    {value: 'maritime', label: 'Maritime'},
    {value: 'marketing & advertising', label: 'Marketing & Advertising'},
    {value: 'market research', label: 'Market Research'},
    {value: 'mechanical & industrial engineering', label: 'Mechanical & Industrial Engineering'},
    {value: 'media production', label: 'Media Production'},
    {value: 'medical devices', label: 'Medical Devices'},
    {value: 'medical practices', label: 'Medical Practices'},
    {value: 'mining & metals', label: 'Mining & Metals'},
    {value: 'mobile games', label: 'Mobile Games'},
    {value: 'motion pictures & film', label: 'Motion Pictures & Film'},
    {value: 'music', label: 'Music'},
    {value: 'nanotechnology', label: 'Nanotechnology'},
    {value: 'newspaper', label: 'Newspaper'},
    {value: 'nonprofit .. (ngo)', label: 'Nonprofit .. (NGO)'},
    {value: 'oil & energy', label: 'Oil & Energy'},
    {value: 'online media', label: 'Online Media'},
    {value: 'outsourcing/offshoring', label: 'Outsourcing/offshoring'},
    {value: 'package/freight delivery', label: 'Package/Freight Delivery'},
    {value: 'packaging & container', label: 'Packaging & Container'},
    {value: 'paper & forest products', label: 'Paper & Forest Products'},
    {value: 'pharma', label: 'Pharma'},
    {value: 'plastics', label: 'Plastics'},
    {value: 'primary/secondary education', label: 'Primary/Secondary Education'},
    {value: 'printing', label: 'Printing'},
    {value: 'pro training & coaching', label: 'Pro Training & Coaching'},
    {value: 'public relation &…', label: 'Public Relation &…'},
    {value: 'public safety', label: 'Public Safety'},
    {value: 'publishing', label: 'Publishing'},
    {value: 'ranching', label: 'Ranching'},
    {value: 'real estate', label: 'Real Estate'},
    {value: 'renewable & environment', label: 'Renewable & Environment'},
    {value: 'research', label: 'Research'},
    {value: 'restaurant', label: 'Restaurant'},
    {value: 'retails', label: 'Retails'},
    {value: 'security & investigation', label: 'Security & Investigation'},
    {value: 'semiconductor', label: 'Semiconductor'},
    {value: 'sporting goods', label: 'Sporting Goods'},
    {value: 'staffing & recruiting', label: 'Staffing & Recruiting'},
    {value: 'supermarket', label: 'Supermarket'},
    {value: 'telecomunication', label: 'Telecomunication'},
    {value: 'textile', label: 'Textile'},
    {value: 'tobacco', label: 'Tobacco'},
    {value: 'translation & localization', label: 'Translation & Localization'},
    {value: 'transportation/trucking/railroad', label: 'Transportation/Trucking/Railroad'},
    {value: 'utilities', label: 'Utilities'},
    {value: 'venture capital & private equity', label: 'Venture Capital & Private Equity'},
    {value: 'veterinary (thú y)', label: 'Veterinary (thú y)'},
    {value: 'warehousing', label: 'Warehousing'},
    {value: 'wholesale', label: 'Wholesale'},
    {value: 'wine & spirit', label: 'Wine & Spirit'},
    {value: 'wireless', label: 'Wireless'},
    {value: 'writing & editing', label: 'Writing & Editing'}
];

export const ResponseCode = {
    SUCCESS: 0,
    EXTRACT_CV_FAILED: 1,
    SAVE_CANDIDATE_FAILED: 2,
    NOT_FOUND_CANDIDATE: 3,
    NAME_OR_PASSWORD_INCORRECT: 4,
    EXISTS_GREATER_TWO_SAME_CV: 5,
    NOT_FOUND_DATA: 6,
    PHONE_EMAIL_USED_BY_OTHER_USER: 7,
    EXTRACT_TEXT_FAILED: 8,
    ACCESS_DENIES: 9,
    INVALID_LOGIN_TOKEN: 10,
    USERNAME_OR_EMAIL_INCORRECT: 11,
    ACCOUNT_LOCKED: 12,
    REQUIRE_TO_CHANGE_PASSWORD: 13,
    NEW_AND_CONFIRM_PASSWORD_NOT_MATCH: 14,
    SAVE_CANDIDATE_GROUP_FAILED: 15,
    ADD_CANDIDATE_INTO_GROUP_FAILED: 16,
    REMOVE_CANDIDATE_OUT_GROUP_FAILED: 17,
    USERNAME_EXISTS: 18,
    PHONE_EXISTS: 19,
    EMAIL_EXISTS: 20,
    HAS_NO_PERMISSION: 21,
    GET_DICTIONARY_FAILED: 22,
    SAVE_DICTIONARY_FAILED: 23,
    NEED_WAITING_APPROVE: 24,
    NOTIFICATION_REJECTED: 25,
    NOTIFICATION_APPROVED: 26,
    CAN_NOT_VIEW_CANDIDATE: 27,
    HAVE_DIFF_FIELD_ONE_VALUE: 28,
    CAN_NOT_VIEW_JOB: 29,
    UPLOAD_JD_FAILED: 30,
    SAVE_USER_INFO_FAILED: 31,
    NOT_FOUND_JOB: 32,
    REQUIRED_JOB_ID: 33,
    REQUIRED_PERSON_ID: 34,
    PIPE_LINE_RULE_OVER_MAX_TIME: 35,
    PIPE_LINE_RULE_CREATED_USER: 36,
    PIPE_LINE_RULE_INTERNAL_PROCESS_VALUE: 37,
    EXISTS_MST: 38,
    EXISTS_SAVED_LIST: 39,
    PIPE_LINE_ALREADY_BOOKED: 40,
    PIPE_LINE_RULE_HAVE_NOT_PERMISSION_EMAIL_INVITE_JOB: 41,
    PIPE_LINE_RULE_NOT_YET_BOOKED_JOB: 42,
    PIPE_LINE_RULE_CAN_NOT_CHAT_BEFORE_UV_REJECT_EMAIL: 43,
    PIPE_LINE_RULE_PERSON_EMAIL_NOT_BLANK: 44,
    PIPE_LINE_RULE_MUST_INVITED_EMAIL_OR_CALL_CHAT: 45,
    PIPE_LINE_RULE_HAVE_OTHER_RECORD_BOOKED_OVER_HOUR: 46,
    CANDIDATE_NOT_HAVE_EMAIL_TO_SEND: 47,
    REQUIRED_EMAIL_SUBJECT: 48,
    EMAIL_TO_SEND_SAME_ERROR_BLOCK_EMAIL: 49,
    REQUIRED_TEMPLATE_ID: 50,
    SOURCE_JOB_HAS_NO_BOOKED_PIPELINES: 51,
    NOT_FOUND_RECEIVER: 52,
    DVTJCUV_RULE_INPUT_SERVICE_STATUS: 53,
    DVTJCUV_CURRENT_USE_TIME_NOT_EXPIRED: 54,
    DVTJCUV_PIPELINE_CAN_NOT_EDIT: 55,
    REQUIRED_RECEIVER_ID: 56,
    UPDATE_ACTIVE_TIME_INVALID: 57,

    SERVER_FAILURE: 9999
}

export const ORDER_BY = {
    ASC_UPDATE_DATE: 1,
    DESC_UPDATE_DATE: 2,
}

export const ODER_BY_TYPE = {
    ASC: 1,
    DESC: 2
}

export const CANDIDATE_GROUP_ORDER_BY = {
    DESC_UPDATE_DATE: 1,
    ASC_UPDATE_DATE: 2,
    AZ: 3,
    ZA: 4
}

export const USER_ROLE = {
    ADMIN: 1,
    EMPLOYEE: 2,
    CTV: 3
}

export const USER_ROLE_LIST = [
    {name: "Admin", value: 1},
    {name: "EMPLOYEE", value: 2},
    {name: "CTV", value: 3}
]

export const DEFAULT_PAGE_SIZE = 10
export const DEFAULT_PAGE = 1

export const DEFAULT_ADMIN_NAME = 'Trang';

export const CONTACT_NO_NEED_APPROVE_FIELDS = [
    {key: 'facebook', label: 'Link profile FB'},
    {key: 'linkedin', label: 'Link profile Linkedin'},
    {key: 'vnw', label: 'Link profile VNW'},
    {key: 'cb', label: 'Link profile CB'},
    {key: 'js', label: 'Link profile JS'},
    {key: 'topcv', label: 'Link profile Topcv'},
    {key: 'other', label: 'Contacts khác'},
    {key: 'deleted_contact', label: 'Contacts bị xóa'}
];

export const CONTACT_NEED_APPROVE_FIELDS = [
    {key: 'phone', label: 'SĐT di động'},
    {key: 'home_phone', label: 'SĐT Nhà'},
    {key: 'rarely_phone', label: 'SĐT di dộng ít dùng'},
    {key: 'ever_phone', label: 'SĐT di động TỪNG dùng'},
    {key: 'email', label: 'Email cá nhân'},
    {key: 'email_to_send', label: 'Email cá nhân (to send)'},
    {key: 'email_to_send_ad', label: 'Emai to send Ad ấn định'},
    {key: 'rarely_email', label: 'Email cá nhân ít dùng'},
    {key: 'ever_email', label: 'Email TỪNG dùng/lỗi'},
    {key: 'block_email', label: 'Email blocked'},
    {key: 'skype', label: 'nick Skype'},
    {key: 'whats_app', label: 'nick Whatsapp'},
    {key: 'lines', label: 'nick Line'},
];

export const ONLY_ONE_VALUE_NEED_APPROVE_FIELDS = [
    {key: 'full_name', label: 'Họ & tên'},
    {key: 'last_name', label: 'Họ'},
    {key: 'vn_name', label: 'Tên VN'},
    {key: 'foreign_name', label: 'Tên nước ngoài'},
    {key: 'email_name', label: 'Tên (Email)'},
    {key: 'gender', label: 'Giới tính'},
];

export const USER_INPUT_IN_PRIORITY_TIME_RANGE_FIELDS = [
    {key: 'username', label: 'User NL'},
    {key: 'candidate_id', label: 'Ứng viên ID'},
    {key: 'inputted_date_time', label: 'Ngày NL'},
    {key: 'start_pri_input_date', label: 'Thời gian NL ưu tiên bắt đầu'},
    {key: 'end_pri_input_date', label: 'Thời gian NL ưu tiên kết thúc'},
];

export const MJ_CANDIDATE_CATEGORY_FIELDS = [
    {key: 'mj_industry', label: 'Industry (MJ)', textColor: 'text-danger'},
    {key: 'mj_industry_segment1', label: 'Industry - phân khúc 1 (MJ)', textColor: ''},
    {key: 'mj_industry_segment2', label: 'Industry - phân khúc 2 (MJ)', textColor: ''},
    {key: 'mj_function', label: 'Function (MJ)', textColor: 'text-danger'},
    {key: 'mj_function_segment1', label: 'Function - phân khúc 1 (MJ)', textColor: ''},
    {key: 'mj_function_segment2', label: 'Function - phân khúc 2 (MJ)', textColor: ''},
];

export const RC_CANDIDATE_CATEGORY_FIELDS = [
    {key: 'rc_industry', label: 'Industry (RC)', textColor: 'text-danger'},
    {key: 'rc_industry_segment1', label: 'Industry - phân khúc 1 (RC)', textColor: ''},
    {key: 'rc_industry_segment2', label: 'Industry - phân khúc 2 (RC)', textColor: ''},
    {key: 'rc_function', label: 'Function (BB)', textColor: 'text-danger (RC)'},
    {key: 'rc_function_segment1', label: 'Function - phân khúc 1 (RC)', textColor: ''},
    {key: 'rc_function_segment2', label: 'Function - phân khúc 2 (RC)', textColor: ''},
];

export const INPUT_YES_NO_SEARCH_BASIC_FIELDS = [
    {key: 'phone', label: 'SĐT di động'},
    {key: 'home_phone', label: 'SĐT Nhà'},
    {key: 'rarely_phone', label: 'SĐT di dộng ít dùng'},
    {key: 'ever_phone', label: 'SĐT di động TỪNG dùng'},
    {key: 'email', label: 'Email cá nhân'},
    {key: 'email_to_send', label: 'Email cá nhân (to send)'},
    {key: 'rarely_email', label: 'Email cá nhân ít dùng'},
    {key: 'ever_email', label: 'Email TỪNG dùng/lỗi'},
    {key: 'block_email', label: 'Email blocked'},
    {key: 'email_name', label: 'Tên (Email)'},
    {key: 'local_area_email', label: 'Vùng miền (Email)'},
    {key: 'highest_level', label: 'Highest Level'},
    {key: 'caller_name_to_email', label: 'Gọi UV là (Email)'},
    {key: 'vocative', label: 'User xưng là (email)'},

    {key: 'service_status', label: 'Trạng thái SD DV',},
    {key: 'current_find_job_mode', label: 'Chế độ tìm job',},
    {key: 'dvtjcuv_find_job_mode', label: 'Chế độ tìm job (DVTJCUV)'},

    {key: 'to_match_job', label: 'To match job'},
    {key: 'to_receive_cdd', label: 'To receive Cdd'},

];


export const INPUT_YES_NO_SEARCH_FIELDS = [
    ...INPUT_YES_NO_SEARCH_BASIC_FIELDS,
    // ...MJ_CANDIDATE_CATEGORY_FIELDS,
    // ...RC_CANDIDATE_CATEGORY_FIELDS,
]


export const IMPORT_EXCEL_CONTACT_FIELDS = [
    {key: 'phone', label: 'SĐT di động'},
    {key: 'email', label: 'Email cá nhân'},
    {key: 'email_to_send', label: 'Email cá nhân (to send)'},
    {key: 'ever_email', label: 'Email TỪNG dùng/lỗi'},
    {key: 'block_email', label: 'Email blocked'},
    {key: 'skype', label: 'nick Skype'},
    // {key: 'whats_app', label: 'nick Whatsapp'},
    // {key: 'lines', label: 'nick Line'},
    // {key: 'facebook', label: 'Link profile FB'},
    {key: 'linkedin', label: 'Link profile Linkedin'},
    {key: 'vnw', label: 'Link profile VNW'},
]

export const PHONE_FILED_NAME = [
    'phone', 'home_phone', 'rarely_phone', 'ever_phone'
]

export const EMAIL_FILED_NAME = [
    'email', 'email_to_send', 'rarely_email', 'ever_email', 'block_email'
]

export const CANDIDATE_CATEGORY_FIELDS = [
    {key: 'industry', label: 'Industry (BB)', textColor: 'text-danger'},
    {key: 'industry_segment1', label: 'Industry - phân khúc 1', textColor: ''},
    {key: 'industry_segment2', label: 'Industry - phân khúc 2', textColor: ''},
    {key: 'function', label: 'Function (BB)', textColor: 'text-danger'},
    {key: 'function_segment1', label: 'Function - phân khúc 1', textColor: ''},
    {key: 'function_segment2', label: 'Function - phân khúc 2', textColor: ''},
    {key: 'industry_function', label: 'Industry Function (Linkedin)', textColor: ''},
    // {key: 'latest_stable_level', label: 'Latest Stable Level'}
];

export const LOCAL_STORAGE_AUTH_TOKEN = 'gopa.crm.auth.token'
export const LOCAL_STORAGE_USER_LOGIN_INFO = 'gopa.crm.auth.user.login.info'
export const LOCAL_STORAGE_ALL_CANDIDATE_IDS = 'gopa.crm.search.all.candidate.ids'
export const LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN = 'gopa.crm.dvtjcuv.next.follow.up.plan'


export const MergeType = {
    GIAO: '1',
    HOP: '2',
    TRU: '3',
}

export const NotifyStatus = {
    WAITING: 1,
    APPROVED: 2,
    REJECTED: 3,
}

export const PriorityInputUserStatus = {
    WAITING: 1,
    APPROVED: 2,
    REJECTED: 3,
}

export const NotifyType = {
    UPDATE_CONTACTS: 1,
    REPORT_WRONG_INPUT: 2,
    DIFF_OTHER_INPUT_ONE_VALUE_FIELD: 3,
    // Gửi thông báo đến admin trong trường hợp user NL UV trong thời gian ưu tiên
    USER_INPUT_IN_PRIORITY_TIME_RANGE: 4,
    BOOKING_REJECTED_INFORM: 5,
    USER_BLOCK_UV: 6,
}

export const LATEST_STABLE_LEVELS = [
    ""
    , "CEO / GĐ điều hành, Tổng Giám đốc, PTGĐ, General Director, General Manager, Operation Mgr, Quản lý nhiều Division"
    , "Quản lý cấp trung (Director, Manager,... & cấp phó)"
    , "Quản lý cấp thấp (Trưởng nhóm, Giám sát, Supervisor, Team Leader, Superintendent,...)"
    , "Senior Staff"
    , "Staff"
]

export const CANDIDATE_ORIGINS = [
    "Linkedin"
    , "SQL"
    , "VNW, CB, JS"
    , "Data CTC"
    , "UV gửi thông tin qua email"
    , "List sưu tầm từ Internet"
    , "Others"
    , "Refer"
    , "Check Ref"
    , "User UV gửi thông tin qua web"
    , "CTV"
    , "File excel trước GP"
    , "Facebook"
]

export const CANDIDATE_ORIGINS_OPTIONS = CANDIDATE_ORIGINS.map(item => {
    return {
        value: item.toLowerCase(),
        label: item.charAt(0).toUpperCase() + item.slice(1)
    };
})

export const CANDIDATE_ORIGIN_APPROVE_STATUS_OPTIONS = [
    {value: '1', label: 'Chưa xem xét'},
    {value: '2', label: 'Đã duyệt'},
    {value: '3', label: 'Không duyệt'},
];

export const SHOW_CANDIDATE_MODE = [
    {value: '1', label: 'Show'},
    {value: '2', label: 'Hide'},
];

export const CANDIDATE_INPUT_INFO_TYPES = {
    Personal: 'Personal',
    Location: 'Location',
    Contacts: 'Contacts',
    Career: 'Career',
    CandidateCategory: 'CandidateCategory',
    FlowCategory: 'FlowCategory',
    CandidateNotes: 'CandidateNotes',
    Origin: 'Origin',
    CandidateCertificate: 'CandidateCertificate',
    QuickShot: 'QuickShot',
    JobSeeking: 'JobSeeking',
    CandidateLanguage: 'Language',
}

export const CANDIDATE_INPUT_INFO_TYPES_OPTIONS = [
    {value: 'Personal', label: 'TT cá nhân'},
    {value: 'Location', label: 'Locations'},
    {value: 'Contacts', label: 'Contacts'},
    // {value: 'Career', label: 'TT nghề nghiệp'},
    // {value: 'CandidateCategory', label: 'Phân loại'},
    // {value: 'FlowCategory', label: 'Phân luồng'},
    // {value: 'CandidateNotes', label: 'Notes'},
];

export const BLOCK_STATE = [
    '',
    'Unblock',
    'Blocked',
];

export const STANDARD_SEARCH_IGNORE = [
    '',
    'N/A',
    'Loại UV',
];

export const CANDIDATE_KNOW_STATE = [
    '',
    'N/A',
    'UV lạ',
    'UV quen chưa giới thiệu GP',
    'UV quen đã giới thiệu GP',
];

export const CANDIDATE_TYPE = [
    '',
    'N/A',
    'Xịn, chất',
    'Không có kno core',
    'Thường làm Công ty xịn',
    'Chất lượng chưa phù hợp để gth cho các Emp',
];

export const PersonTypeOptions = CANDIDATE_TYPE.map((item, index) => {
    return {label: item, value: index}
})

export const GENDERS = [
    'Nam',
    'Nữ',
    'Không rõ',
    'LGBT'
];

export const MAX_PAGE_LINK_DISPLAY = 7

export const ExtractType = {
    UPLOAD_CV: 1,
    INPUT_FORM: 2,
    IMPORT_EXCEL: 3
}

// Các trường chỉ admin mới nhìn thấy
export const OnlyAdminViewFields = {
    // CandidateNotes
    engagement_status: {parent: 'allCandidateNotesInfo', title: 'Engagement Status'},
    support_title: {parent: 'allCandidateNotesInfo', title: 'Danh hiệu support'},
    current_find_job_mode: {parent: 'allJobSeekingInfo', title: 'Chế độ tìm job hiện tại'},
    fate_type: {parent: 'allCandidateNotesInfo', title: 'Loại duyên nợ'},
    support_level: {parent: 'allCandidateNotesInfo', title: 'Khả năng support'},
    support_ready_level: {parent: 'allCandidateNotesInfo', title: 'Mức độ sẵn sàng support'},
    note_for_refer_support: {parent: 'allCandidateNotesInfo', title: 'Note (for Nhờ Refer, Hỗ trợ)'},

    // Job
    job_title_to_send: {parent: '', title: 'Job Title (to send)'},
    work_address_to_send: {parent: '', title: 'Địa điểm LV (to send)'},
    required_candidate_to_send: {parent: '', title: 'Yêu cầu đối với UV (to send)'},
    working_time_to_send: {parent: '', title: 'Thời gian LV (to send)'},
    about_employer_to_send: {parent: '', title: 'Thông tin về Employer (to send)'},

    // Origin
    origin: {parent: '', title: 'Nguồn UV'},
}

// Các trường mọi user đều nhìn thấy
export const CommonUseFields = {
    // Personal
    foreign_name: {parent: 'allPersonalInfo', title: 'Tên nước ngoài'},
    last_name: {parent: 'allPersonalInfo', title: 'Họ'},
    mid_name: {parent: 'allPersonalInfo', title: 'Tên đệm'},
    vn_name: {parent: 'allPersonalInfo', title: 'Tên VN'},
    full_name: {parent: 'allPersonalInfo', title: 'Họ & tên'},
    other_first_name: {parent: 'allPersonalInfo', title: 'Tên biệt danh/khác'},
    email_name: {parent: 'allPersonalInfo', title: 'Tên (email)'},
    paper_dob: {parent: 'allPersonalInfo', title: 'Ngày sinh (giấy tờ)'},
    paper_mob: {parent: 'allPersonalInfo', title: ''},
    paper_yob: {parent: 'allPersonalInfo', title: ''},
    actual_dob: {parent: 'allPersonalInfo', title: ''},
    actual_mob: {parent: 'allPersonalInfo', title: ''},
    actual_yob: {parent: 'allPersonalInfo', title: ''},
    guess_age: {parent: 'allPersonalInfo', title: 'Tuổi (dự đoán)'},
    gender: {parent: 'allPersonalInfo', title: 'Giới tính'},

    // Location
    local_nationality: {parent: 'allLocationsInfo', title: 'Quốc tịch'},
    local_ever_work_nationality: {parent: 'allLocationsInfo', title: 'Nước ngoài từng làm việc'},
    local_address: {parent: 'allLocationsInfo', title: 'Địa chỉ'},
    local_province: {parent: 'allLocationsInfo', title: 'Local tỉnh'},
    local_province_email: {parent: 'allLocationsInfo', title: 'Local tỉnh (email)'},
    local_area: {parent: 'allLocationsInfo', title: 'Location Miền'},
    local_area_email: {parent: 'allLocationsInfo', title: 'Location Miền (Email)'},
    local_note: {parent: 'allLocationsInfo', title: 'Local note'},

    // Contacts
    phone: {parent: 'allContactsInfo', title: 'Số ĐT'},
    home_phone: {parent: 'allContactsInfo', title: 'Home phone'},
    rarely_phone: {parent: 'allContactsInfo', title: 'SĐT ít dùng'},
    ever_phone: {parent: 'allContactsInfo', title: 'Số ĐT từng dùng'},
    email: {parent: 'allContactsInfo', title: 'Email'},
    email_to_send: {parent: 'allContactsInfo', title: 'Email cá nhân (to send)'},
    rarely_email: {parent: 'allContactsInfo', title: 'Email cá nhân ít dùng'},
    ever_email: {parent: 'allContactsInfo', title: 'Email từng dùng/lỗi'},
    block_email: {parent: 'allContactsInfo', title: 'Email bị khoá'},
    skype: {parent: 'allContactsInfo', title: 'Skype'},
    whats_app: {parent: 'allContactsInfo', title: 'Whats app'},
    lines: {parent: 'allContactsInfo', title: 'Line'},
    facebook: {parent: 'allContactsInfo', title: 'Facebook'},
    linkedin: {parent: 'allContactsInfo', title: 'Linkedin'},
    vnw: {parent: 'allContactsInfo', title: 'VNW'},
    cb: {parent: 'allContactsInfo', title: 'CB'},
    js: {parent: 'allContactsInfo', title: 'JS'},
    topcv: {parent: 'allContactsInfo', title: 'Topcv'},
    other: {parent: 'allContactsInfo', title: 'ohter'},
    deleted_contact: {parent: 'allContactsInfo', title: 'contact đã xóa'},

    // CandidateCategory
    industry: {parent: 'allCandidateCategoriesInfo', title: 'Industry'},
    industry_segment1: {parent: 'allCandidateCategoriesInfo', title: 'Industry - phân khúc 1'},
    industry_segment2: {parent: 'allCandidateCategoriesInfo', title: 'Industry - phân khúc 2'},
    function: {parent: 'allCandidateCategoriesInfo', title: 'Function'},
    function_segment1: {parent: 'allCandidateCategoriesInfo', title: 'Function - phân khúc 1'},
    function_segment2: {parent: 'allCandidateCategoriesInfo', title: 'Function - phân khúc 2'},
    industry_function: {parent: 'allCandidateCategoriesInfo', title: 'Industry Function (Linkedin)'},
    company_type: {parent: 'allCandidateCategoriesInfo', title: 'Industry'},
    keyword_tag: {parent: 'allCandidateCategoriesInfo', title: 'Industry'},
    levels: {parent: 'allCandidateCategoriesInfo', title: 'Industry'},
    highest_level: {parent: 'allCandidateCategoriesInfo', title: 'Highest level'},
    latest_stable_level: {parent: 'allCandidateCategoriesInfo', title: 'Latest stable level'},
    new_work_level: {parent: 'allCandidateCategoriesInfo', title: 'New work level'},
    unknown_level: {parent: 'allCandidateCategoriesInfo', title: 'Unknown level'},
    // ctv_level: {parent: 'allCandidateCategoriesInfo', title: 'CTV level'},

    // FlowCategory
    // show_hide_state: {parent: 'allFlowCategoriesInfo', title: 'Hide/Show'},
    candidate_know_state: {parent: 'allFlowCategoriesInfo', title: 'UV lạ/quen', options: CANDIDATE_KNOW_STATE},
    object_special: {parent: 'allFlowCategoriesInfo', title: 'Đối tượng đặc biệt'},
    standard_search_ignore: {
        parent: 'allFlowCategoriesInfo',
        title: 'Loại UV khỏi Search tiêu chuẩn',
        options: STANDARD_SEARCH_IGNORE
    },
    // input_me_list: {parent: 'allFlowCategoriesInfo', title: 'Nhập list ME'},
    block_state: {parent: 'allFlowCategoriesInfo', title: 'Block UV', options: BLOCK_STATE, notUnique: true},
    job_send_request: {parent: 'allFlowCategoriesInfo', title: 'Yêu cầu gửi job'},
    candidate_type: {parent: 'allFlowCategoriesInfo', title: 'Xếp loại UV', options: CANDIDATE_TYPE},
    flow_note: {parent: 'allFlowCategoriesInfo', title: 'Note (Phân luồng)'},
    flow_history: {parent: 'allFlowCategoriesInfo', title: 'Flow history'},

    // CandidateCertificate
    provider_year: {parent: 'allCandidateCertificatesInfo', title: 'Năm cấp'},
    special_certificate: {parent: 'allCandidateCertificatesInfo', title: 'Chứng chỉ đặc biệt'},
    organizer: {parent: 'allCandidateCertificatesInfo', title: 'Tổ chức'},
    note: {parent: 'allCandidateCertificatesInfo', title: 'Note'},

    // CandidateNotes
    general_note: {parent: 'allCandidateNotesInfo', title: 'General note'},
    important_note: {parent: 'allCandidateNotesInfo', title: 'Lưu ý quan trọng khi tương tác'},

    // Languages
    english: {title: 'Tiếng Anh', parent: 'allLanguagesInfo'},
    english_note: {title: 'Note TA', parent: 'allLanguagesInfo'},
    france: {title: 'Tiếng Pháp', parent: 'allLanguagesInfo'},
    france_note: {title: 'Note T.Pháp', parent: 'allLanguagesInfo'},
    china: {title: 'Tiếng Trung', parent: 'allLanguagesInfo'},
    china_note: {title: 'Note T.Trung', parent: 'allLanguagesInfo'},
    korea: {title: 'Tiếng Hàn', parent: 'allLanguagesInfo'},
    korea_note: {title: 'Note T.Hàn', parent: 'allLanguagesInfo'},
    japanese: {title: 'Tiếng Nhật', parent: 'allLanguagesInfo'},
    japanese_note: {title: 'Note TN', tparent: 'allLanguagesInfo'},
    russian: {title: 'Tiếng Nga', parent: 'allLanguagesInfo'},
    russian_note: {title: 'Note T.Nga', parent: 'allLanguagesInfo'},
    others: {title: 'Ngôn ngữ khác', parent: 'allLanguagesInfo'},
    common_notes: {title: 'Notes chung', parent: 'allLanguagesInfo'}
}


export const CONTACT_SEARCH_FIELDS = [
    {key: 'phone', label: 'SĐT di động'},
    {key: 'email', label: 'Email'},
    {key: 'skype', label: 'nick Skype'},
    {key: 'whats_app', label: 'nick Whatsapp'},
    {key: 'lines', label: 'nick Line'},
];
